export const refs = {
    categoryList: document.querySelector('ul.categories'),
    productsList: document.querySelector('.products'),
    loadMoreBtn: document.querySelector('.load-more-btn'),
    notFound: document.querySelector('.not-found'),
    modal: document.querySelector('.modal'),
    modalProduct: document.querySelector('.modal-product'),
    modalCloseBtn: document.querySelector('.modal__close-btn'),
    searchForm: document.querySelector('.search-form'),
    searchInput: document.querySelector('.search-form__input'),
    searchFormBtn: document.querySelector('.search-form__btn'),
    searchFormClearBtn: document.querySelector('.search-form__btn-clear'),
    addToCartBtn: document.querySelector('.modal-product__cart-btn'),
    themeBtn: document.querySelector('.theme-toggle-btn'),
body: document.body,
}